import styled from "styled-components";

export const Container = styled.div`
    position: absolute;
    width: 16.678125rem;
    height: 33.1875rem;;
    z-index: 50;
    right: ${({ retract }) => retract ? "-16.678125rem" : "1rem"};
    top: 5.75rem;
    user-select: none;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    background-color: #fff;
    border-radius: 0.17625rem;
    cursor: auto;


    transition: right ease 0.3s;
    

`;



export const Sections = styled.div`
  display: flex;
  justify-content: space-evenly;
  font-size: 0.646875rem;
  margin-left: 0.8rem;
  margin-top: 1.294375rem;
  margin-bottom: 0.8rem;
`;
export const Option = styled.span`
  display: ${({ disable }) => disable ? 'none' : 'inline-block'};
  font-size: 0.8rem;
  cursor: pointer;
  font-weight: 600;
  color: ${({ active, colorActive }) => (active ? colorActive ? colorActive : '#232323' : '#A9AEB4')};
  transition: color 0.5s ease;

`;
export const ACC = styled.div`
  margin-top: .4rem;
  display: flex;
  flex-direction: column;
  margin-left: 0.8rem;
  border: 0.941243px solid #d4d6da;
  border-radius: 0.0764rem;
  width: 12.883125rem;
  font-size: 0.70625rem;
  height: 52px;

    span{
        font-size: 0.70625rem;
        margin-left: 0.889375rem;
        display: inline-block;
    }



`;


export const ULJobs = styled.ul`
  list-style: none;
  overflow-y: auto;
  padding-left: 0.8rem;

  max-height: 21rem;


  li:first-child{
      padding-top: 0;
    }

  li:last-child{
      padding-bottom: 0;
    }

  ::-webkit-scrollbar {
    width: 3px;
    height: 6px;
 
  }

  ::-webkit-scrollbar-thumb {
    background: #118052;
    width: 5px;
    border-radius: 6px;
  }


`;


export const JobItem = styled.li`
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0.2rem 0.2rem 0.2rem 0;
    button{
      width: 100%;
      padding: 0.5rem 0;
      font-weight: 600;
      font-size: 0.8rem;

      &:hover{
        filter: brightness(0.8);

      }
      color: ${({ status }) =>
    status === 'doing' ? "#807228" :
      status === 'late' ? "#D93333" :
        status === 'done' ? "#118052" :
          status === 'doneLate' ? "#D93333" :
            status === 'pending' ? "#585E66" : null
  };

      border: ${({ status }) =>
    status === 'doing' ? "1px solid #807228" :
      status === 'late' ? "1px solid #D93333" :
        status === 'done' ? "1px solid #118052" :
          status === 'doneLate' ? "1px solid #D93333" :
            status === 'pending' ? "1px solid #585E66" : null
  };

      background: ${({ status }) =>
    status === 'doing' ? "#fffdd3" :
      status === 'late' ? "#fdd6cd" :
        status === 'done' ? "#cff8e7" :
          status === 'doneLate' ? "#cff8e7" :
            status === 'pending' ? "#ffffff" : null
  }

    }
    
    svg{
        path{
          fill: #40e5a0;
        }
        &:hover{
          path{
            fill: #118052;
          }
      }

   }  
`

export const RetractButton = styled.button`

   position: absolute;
   top: 0.5rem;
   width: 2.3rem;
   height: 2.3rem;
   left: -1.6rem;
   border-radius: 50%;
   border: none;
   background-color: #40e5a0;

   display: flex;
   align-items: center;
   justify-content: center;


   svg{
     transform: ${({ retract }) => !retract ? "rotate(180deg)" : null} ;
    }

`;



export const MenuOptions = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: 0 auto;
    
         
`;